<template>
    <j-page>
        <div class="encrypt-textarea" slot="table">
            <div class="textarea-left">
                <el-input style="height: 100%" type="textarea" placeholder="加密字符串" v-model="textarea"/>
            </div>
            <div class="textarea-center">
                <el-button :disabled="textarea.length < 1" @click="encryptEvent">解密</el-button>
                <el-button :disabled="textarea.length < 1" @click="textarea = '';result = '';">重置</el-button>
            </div>
            <div class="textarea-right">
<!--                <el-input style="height: 100%" type="textarea" placeholder="解密结果" v-model="result"/>-->
              <JsonViewer :value="result" expanded copyable :expand-depth="10" />
            </div>
        </div>
    </j-page>
</template>

<script>
    import PageMixins from "../../components/JComponents/JPage/mixins/PageMixins";
    import Encrypt from "@/utils/encrypt/encrypt";
    import JsonViewer from 'vue-json-viewer'
    export default {
        name: "JDecodeTool",
        mixins: [PageMixins],
        components: {
          JsonViewer
        },
        data() {
            return {
                textarea: '',
                result: ''
            }
        },
        methods: {
            encryptEvent () {
                this.result = Encrypt.decryptString(this.textarea.replace(/^"|"$/g, ''))
                if (this.result) {
                    this.$message.success('控制台已同步输出结构体')
                    try {
                        console.dir(JSON.parse(this.result))
                      this.result = JSON.parse(this.result)
                    } catch (e) {
                      console.log(this.result)
                      this.result = ""
                    }
                }
            }
        }
    }
</script>

<style lang="scss">
    .encrypt-textarea {
        display: flex;
        .el-textarea__inner {
            height: 100%;
            resize:none;
        }
        .textarea-left, .textarea-right {
            flex: 1;
            min-width: 100px;
        }
        .textarea-right {
          border: 1px solid #DCDFE6;
          border-radius: 4px;
          overflow: auto;
        }
        .textarea-center {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100%;
            padding: 0 5px;
            .el-button {
                margin: 5px 0;
            }
        }
    }
</style>
